import { getData } from '../apiClient';

/**
 * Get Attendance Report with dynamic filters
 * @param {Object} params - { startDate, endDate, employeeId, startTime, endTime }
 */
export const getAttendanceReport = (params) => {
    return getData("attendance-report/report", params);
};
